import request from '../tools/request'
import { GetLocalStorage, getSupplierId, getUserId } from '../tools/util'
import { HTTP } from './http'
const { uploadFilePOST } = request
// ! 导入类api

export type uploadType = '1' | '2' | '3' | '4' | '5' | 'brand' | 'product'
// 上传文件 type 1主图 2详情图 3品牌图 4附件 productCode物料编码
export const UPLOAD_FILE = (
  params: {
    type: uploadType
    fileType?: string
    productCode?: string
    code?: string
  },
  file: any,
) => uploadFilePOST(`${HTTP}/upload/uploadPic`, file, params)

// 批量修改物料价格
export const UPLOADFILE_GOODS_PRICE = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/updatePriceExcel`, [file])

// 批量修改物料产品经理
export const UPLOADFILE_GOODS_PRODUCT = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/updateProductManagerFromExcel`, [file])

// 批量修改物料禁用
export const UPLOADFILE_GOODS_DISABLED = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/updateProductIsDisabledFromExcelAsync`, [
    file,
  ])

// 批量修改物料使用组织
export const UPLOADFILE_GOODS_USEORG = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/batchUpdateByType`, [file], {
    type: '6',
  })

// 批量修改物料推送
export const UPLOADFILE_GOODS_PUSH = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/pushProductFromExcel`, [file])

// 批量修改物料执行人
export const UPLOADFILE_GOODS_STOCK = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/updateRemoveStockManExcel`, [file])

// 批量修改毛重
export const UPLOADFILE_CROSS_WEIGHT = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/updateGrossWeightExcel`, [file])

// 批量修改旧物料编码
export const UPLOADFILE_GOODS_OLDCODE = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/updateOldCodeExcel`, [file])

// 批量修改货主
export const UPLOADFILE_SHIPPER = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/updateShipperExcel`, [file])

// 批量修改物料信息
export const UPLOADFILE_GOODS_INFO = (file: any, e: { type: string }) =>
  uploadFilePOST(`${HTTP}/productChild/batchUpdateByType`, [file], e)

// 批量修改条形码
export const UPLOADFILE_GOODS_BARCODE = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/updateBarCodeExcel`, [file])

// 批量修改品牌
export const UPLOADFILE_GOODS_BRAND = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/updateBrandExcel`, [file])

// 批量四级类目
export const UPLOADFILE_GOODS_CATEGORY = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/updateCategoryExcel`, [file])

// 品牌导入
export const UPLOADFILE_BRANDDATA = (file: any) =>
  uploadFilePOST(`${HTTP}/brand/importBrand`, [file])

// 品牌-产品经理导入
export const UPLOADFILE_BRAND_PRODUCTMANAGER = (file: any) =>
  uploadFilePOST(`${HTTP}/brand/updateProductManagerFromExcel`, [file])

// 品牌导入禁用
export const UPLOADFILE_BRAND_DISABLE = (file: any) =>
  uploadFilePOST(`${HTTP}/brand/updateIsDisableFromExcel`, [file])

// 生产许可证
export const UPLOADFILE_PRODUCTION = (file: any, parmas?: any) =>
  uploadFilePOST(`${HTTP}/upload/uploadPic`, file, parmas)

/**
 * 待提交物料-批量修改-上架项目
 * @param file
 * @param parmas
 * @returns
 */
export const BATCH_UPDATE_PROJECT = (file: any, params?: any) =>
  uploadFilePOST(`${HTTP}/product/batchUpdateProject`, [file], {
    userId: getUserId(),
    ...params,
  })

/**
 * 待提交物料-批量修改-导入图片
 * @param file
 * @param parmas
 * @returns
 */
export const BATCH_UPDATE_PICTURE = (file: any, params?: any) =>
  uploadFilePOST(`${HTTP}/product/batchUpdatePicture`, [file], {
    userId: getUserId(),
    ...params,
  })

/**
 * 待提交物料-批量修改-导入拓展属性
 * @param file
 * @param parmas
 * @returns
 */
export const BATCH_UPDATE_EXPAND = (file: any) =>
  uploadFilePOST(`${HTTP}/product/importProductUpdateExpand`, file, {
    supplierId: getSupplierId(),
    erpCode: GetLocalStorage('SUPPLIER_ERPCODE'),
    userId: getUserId(),
  })
import request from '../tools/request'
import { GetLocalStorage, getSupplierId, getUserId } from '../tools/util'
import { HTTP } from './http'
const { uploadFilePOST } = request
// ! 导入类api

export type uploadType = '1' | '2' | '3' | '4' | '5' | 'brand' | 'product'
// 上传文件 type 1主图 2详情图 3品牌图 4附件 productCode物料编码
export const UPLOAD_FILE = (
  params: {
    type: uploadType
    fileType?: string
    productCode?: string
    code?: string
  },
  file: any,
) => uploadFilePOST(`${HTTP}/upload/uploadPic`, file, params)

// 批量修改物料价格
export const UPLOADFILE_GOODS_PRICE = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/updatePriceExcel`, [file])

// 批量修改物料产品经理
export const UPLOADFILE_GOODS_PRODUCT = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/updateProductManagerFromExcel`, [file])

// 批量修改物料禁用
export const UPLOADFILE_GOODS_DISABLED = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/updateProductIsDisabledFromExcelAsync`, [
    file,
  ])

// 批量修改物料使用组织
export const UPLOADFILE_GOODS_USEORG = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/batchUpdateByType`, [file], {
    type: '6',
  })

// 批量修改物料推送
export const UPLOADFILE_GOODS_PUSH = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/pushProductFromExcel`, [file])

// 批量修改物料执行人
export const UPLOADFILE_GOODS_STOCK = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/updateRemoveStockManExcel`, [file])

// 批量修改毛重
export const UPLOADFILE_CROSS_WEIGHT = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/updateGrossWeightExcel`, [file])

// 批量修改旧物料编码
export const UPLOADFILE_GOODS_OLDCODE = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/updateOldCodeExcel`, [file])

// 批量修改货主
export const UPLOADFILE_SHIPPER = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/updateShipperExcel`, [file])

// 批量修改物料信息
export const UPLOADFILE_GOODS_INFO = (file: any, e: { type: string }) =>
  uploadFilePOST(`${HTTP}/productChild/batchUpdateByType`, [file], e)

// 批量修改条形码
export const UPLOADFILE_GOODS_BARCODE = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/updateBarCodeExcel`, [file])

// 批量修改品牌
export const UPLOADFILE_GOODS_BRAND = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/updateBrandExcel`, [file])

// 批量四级类目
export const UPLOADFILE_GOODS_CATEGORY = (file: any) =>
  uploadFilePOST(`${HTTP}/productChild/updateCategoryExcel`, [file])

// 品牌导入
export const UPLOADFILE_BRANDDATA = (file: any) =>
  uploadFilePOST(`${HTTP}/brand/importBrand`, [file])

// 品牌-产品经理导入
export const UPLOADFILE_BRAND_PRODUCTMANAGER = (file: any) =>
  uploadFilePOST(`${HTTP}/brand/updateProductManagerFromExcel`, [file])

// 品牌导入禁用
export const UPLOADFILE_BRAND_DISABLE = (file: any) =>
  uploadFilePOST(`${HTTP}/brand/updateIsDisableFromExcel`, [file])

// 生产许可证
export const UPLOADFILE_PRODUCTION = (file: any, parmas?: any) =>
  uploadFilePOST(`${HTTP}/upload/uploadPic`, file, parmas)

/**
 * 待提交物料-批量修改-上架项目
 * @param file
 * @param parmas
 * @returns
 */
export const BATCH_UPDATE_PROJECT = (file: any, params?: any) =>
  uploadFilePOST(`${HTTP}/product/batchUpdateProject`, [file], {
    userId: getUserId(),
    ...params,
  })

/**
 * 待提交物料-批量修改-导入图片
 * @param file
 * @param parmas
 * @returns
 */
export const BATCH_UPDATE_PICTURE = (file: any, params?: any) =>
  uploadFilePOST(`${HTTP}/product/batchUpdatePicture`, [file], {
    userId: getUserId(),
    ...params,
  })

/**
 * 待提交物料-批量修改-导入拓展属性
 * @param file
 * @param parmas
 * @returns
 */
export const BATCH_UPDATE_EXPAND = (file: any) =>
  uploadFilePOST(`${HTTP}/product/importProductUpdateExpand`, file, {
    supplierId: getSupplierId(),
    erpCode: GetLocalStorage('SUPPLIER_ERPCODE'),
    userId: getUserId(),
  })
